define('post-view',['controller', 'comments', 'rating'], function(controller, comments, rating) {	
	function toggleReferences() {
		var more = $(this).data('more');
		var referencesText = $(this).parent().find('.references-text');
		
		referencesText.toggleClass("hide-content");
		referencesText.toggleClass("show-content");
		
		if (more)
			buttonText = "Weniger anzeigen";
		else
			buttonText = "Mehr anzeigen";
		
		$(this).text(buttonText);
		$(this).data('more', !more);
	}
	
	controller.on('posts/view', function() {
		comments.init();
		rating.init();
		
		//show references button only if references-text has overflow
		if ($('.references-text').prop('offsetHeight') < $('.references-text').prop('scrollHeight')) {
			$('#toggle-references-button').show();
			$('.pv-references-section .hide-content').addClass('dashed-bottom-border');
		}
		
		$('#toggle-references-button').click(toggleReferences);
	});
});

